document.addEventListener('DOMContentLoaded', () => {
  // 高さを更新する関数
  function updateElementHeight(entries) {
    entries.forEach((entry) => {
      const height = entry.contentRect.height;

      if (entry.target.classList.contains('header__inner')) {
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      } else if (entry.target.classList.contains('header__logo')) {
        document.documentElement.style.setProperty('--header-logo-height', `${height}px`);
      }
    });
  }

  // ResizeObserver を作成
  const resizeObserver = new ResizeObserver(updateElementHeight);

  // 監視する要素を個別に取得
  const header = document.querySelector('.header__inner');
  const headerLogo = document.querySelector('.header__logo');

  // 各要素を監視
  resizeObserver.observe(header);
  resizeObserver.observe(headerLogo);
});
